import { MyPage } from '../MyPage';
import { BoughtSingleSaleOffers } from './BoughtSingleSaleOffers';
import { useSortByDate } from '../common/useSortByDate';
import { useSportSelect } from '../common/useSportSelect';

export const MyPurchases = () => {
  const { sortType, sortSelectNode } = useSortByDate();
  const { sportInputValue, sportSelectNode } = useSportSelect();

  return (
    <MyPage
      toolbar={
        <>
          {sportSelectNode}
          {sortSelectNode}
        </>
      }
    >
      <BoughtSingleSaleOffers sortType={sortType} sport={sportInputValue} />
    </MyPage>
  );
};
